<template>
  <v-container v-if="personal">
    <v-row>
      <v-col cols="8">
        <div class="text-h6 font-weight-bold">Nacionalidad</div>
      </v-col>
      <v-col cols="4">
        <v-row>
          <v-col cols="12">
            <v-form v-model="nacionalidadForm" ref="nacionalidad">
              <BaseInput
                v-model="personal.nacionalidad"
                :rules="required"
                :readonly="perfil === PERFILES['Administrador IPH+']"
              >
                <template #label>Nacionalidad <span class="red--text">*</span> </template>
              </BaseInput>
              <BaseSelect
                v-model="personal.fk_idTipoNacionalidad"
                :items="tipoNacionalidad"
                :rules="requiredSelect"
                :readonly="perfil === PERFILES['Administrador IPH+']"
              >
                <template #label>Tipo de nacionalidad <span class="red--text">*</span> </template>
              </BaseSelect>
              <v-autocomplete
                v-model="personal.fk_idMunicipioNacimiento"
                rounded
                filled
                dense
                background-color="primary"
                color="secondary"
                :items="municipios"
                item-value="id"
                item-text="nombre"
                item-color="secondary"
                :readonly="perfil === PERFILES['Administrador IPH+']"
              >
                <template v-slot:label>Municipio donde nació <span class="red--text">*</span> </template>
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                    <v-list-item-subtitle>{{ item.catEstado.title }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
              <TextButton
                class="mt-4"
                :disabled="perfil === PERFILES['Administrador IPH+']"
                @click="triggerUpdatePersonal"
              >
                Guardar nacionalidad
              </TextButton>
            </v-form>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
  <v-container v-else>
    <v-row>
      <v-col cols="12" align="center">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import BaseInput from '../../../base/BaseInput.vue'
import BaseSelect from '../../../base/BaseSelect.vue'
import TextButton from '../../../base/TextButton.vue'
import { PERFILES } from '@/perfiles.js'

export default {
  components: {
    BaseInput,
    BaseSelect,
    TextButton,
  },
  data() {
    return {
      PERFILES,
      nacionalidadForm: false,
      required: [(v) => !!v || 'Este campo es obligatorio'],
      requiredSelect: [(v) => !!v || 'Este campo es obligatorio'],
    }
  },
  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
    ...mapGetters({
      perfil: 'getPerfil',
    }),
    ...mapGetters('tipoNacionalidad', {
      tipoNacionalidad: 'getTipoNacionalidad',
    }),
    ...mapGetters('municipio', {
      municipios: 'getMunicipios',
    }),
  },
  methods: {
    ...mapActions('personal', ['fetchPersonalById', 'updatePersonal']),
    ...mapActions('tipoNacionalidad', ['fetchTipoNacionalidad']),
    ...mapActions('municipio', ['fetchMunicipios']),
    async triggerUpdatePersonal() {
      await this.updatePersonal(this.personal)
      this.$emit('updated')
    },
  },
  async mounted() {
    if (!this.tipoNacionalidad.length) {
      await this.fetchTipoNacionalidad()
    }
    if (!this.municipios.length) {
      await this.fetchMunicipios()
    }
  },
}
</script>
